module.exports = __webpack_public_path__ + "img/firewall.8335189.png";